<template>
  <div class="whd-drag-img" style="padding: 0">
    <el-upload
      drag
      :class="{'on':imgUrl}"
      :action="imgHost+uploadImg"
      accept="image/jpeg,image/png"
      :on-success="handleSuccess"
      :on-error="handleError"
      :show-file-list="false"
      :before-upload="beforeUpload"
      :data = "headers"
    >
      <template v-if="imgUrl">
        <img :src="imgUrl" alt="" width="150" style="vertical-align: middle" />
        <span class="whd-video__span" @click.stop="handleDelImg"><i class="el-icon-delete"></i></span>
      </template> 
      <template v-else>
        <i class="el-icon-plus"></i>
      </template>
    </el-upload>
  </div>
</template>

<script>
import api from "@/api.js";
export default {
  name: "uploadSingleImg",
  props: {
    type: {
      type: Number,
      default: 0
    },
    property: {
      type: String,
      default: ""
    },
    index: {
      type: Number,
      default: 0
    },
    imgWidth:{
      type: Number,
      default: 0
    }
  },
  watch: {
    property(val) {
      this.imgUrl = val; 
    }
  },
  data() {
    return {
      headers: {token: sessionStorage.getItem("token")},
      uploadImg: api.uploadFile,
      imgUrl: "",
      imgHost: process.env.NODE_ENV === 'production' ? 'https://b.zaoxiangguan.com' : ''
    }
  },
  mounted() {
    this.imgUrl = this.property;
  },
  methods: {
    handleSuccess(res, file) {
      if (res.code == 0) {
        // console.log('上传成功',res)
        this.imgUrl = res.path;
        this.$emit("updateImg",{img: this.imgUrl, type: this.type, index: this.index});
      } else {
        this.$message({
        type: "error",
        message: res.msg
      });
      }
      this.loadingStatus.close();
    },
    handleError(err, file) {
      this.$message({
        type: "error",
        message: "上传失败"
      });
    },
    beforeUpload(file) {
      let width = this.imgWidth
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      let status = true;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG或者PNG 格式!");
        status = false;
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
        status = false;
      }
      //  if(width){
      //     const isSize = new Promise(function(resolve, reject) {
      //       if(width){
      //         console.log('123isSize',isSize)
      //           // let width = 650;
      //           // let height = 420;
      //           let _URL = window.URL || window.webkitURL;
      //           let image = new Image();
      //           image.onload = function() {
      //             // let valid = image.width == width && image.height == height;
      //             let valid = image.width == width ;
      //             console.log('图片宽度',image.width)
      //             valid ? resolve() : reject();
      //           };
      //           console.log('图片宽度123',image.width)
      //           image.src = _URL.createObjectURL(file);
      //       }  
      // })
      // .then(() => { 
      //     // return file; 
      //   })
      //   .catch(()=>{
      //       status = false;
      //       this.$message.error("上传头像图片尺寸不符合,只能是宽为650的图片!");
             
      //   })
        
       
      // }

      if(status){
       
        this.loadingStatus = this.$loading({
          lock: true,
          text: '上传中',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.4)',
          customClass: 'fontColor'
        });
      }
     
      // if(width){
      //   console.log('123上传width',isJPG && isLt2M && isSize)
      //    return isJPG && isLt2M && isSize;
      // }
      // else{
        
         return isJPG && isLt2M;
      // }
     
      
    },
    handleDelImg() {
      this.imgUrl = "";
      this.$emit("updateImg",{img: this.imgUrl, type: this.type, index: this.index});
    }
  }
}
</script>